import React, { Component } from "react";
import SignupForm from "./SignupForm";
import { Link } from "react-router";
import { Grid, Col, Row } from "react-bootstrap";
import SimplifiedLayout from "../SimplifiedLayout";
import Helmet from 'react-helmet';
import mixpanel from 'mixpanel-browser';

class SignupPage extends Component {

	constructor() {
		super();
		this.mixpanel = mixpanel;
	}

	componentWillMount() {
		if (this.props.location.query["plan"] === "basic") {
			this.mixpanel.track('Plan request', { plan: 'basic'});
		}

		if (this.props.location.query["plan"] === "pro") {
			this.mixpanel.track('Plan request', { plan: 'pro'});
		}
	}

    render() {
        return (
            <div>
            	<Helmet title="Sign Up"/>
                <SimplifiedLayout>
                    <Grid className="text-center">
                        <Row>
                            <Col sm={3} />
                            <Col sm={6}>
                                <SignupForm />
                            </Col>
                            <Col sm={3} />
                        </Row>
                        <Row>
                            <Col sm={12} className="text-center">
                                <Link to="/login">
                                    Already have an account? Log in
                                </Link>
                            </Col>
                        </Row>
                    </Grid>
                </SimplifiedLayout>
            </div>
        );
    }
}

export default SignupPage;



// WEBPACK FOOTER //
// ./src/signup/SignupPage.js